import React from 'react'
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { useDarkMode } from '../hooks/useDarkMode'

export function DarkModeToggle() {
  const [isDark, setDarkMode] = useDarkMode()

  return (
    <button
      type="button"
      onClick={() => setDarkMode(!isDark)}
      className="group rounded-full p-2 text-[color:var(--theme-muted)] hover:bg-[color:var(--theme-hover)] hover:text-[color:var(--theme-fg)]"
      aria-label="Toggle dark mode"
    >
      {isDark ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
    </button>
  )
}
